import {GLOBAL} from "../../common/globals";
import {AlignedSlotsFactory} from "./alignedSlots";
import {HorizontalOverflowFactory} from "./horizontalOverflow";

export interface ReadyElementFeature {
    install: () => this;

    uninstall: () => void;
}

export interface ElementFeatureFactory<T extends ReadyElementFeature = ReadyElementFeature> {
    installOn: (element: Element) => T;
}

export class ElementFeatures {
    public static installElementFeature(id: string, featureFactory: ElementFeatureFactory): void {
        GLOBAL.bodyElement().querySelectorAll<Element>("[" + id + "]")
            .forEach(elem => featureFactory.installOn(elem));
    }

    public static afterContentLoaded(init: () => void): void {
        if (document.readyState === "loading") {
            GLOBAL.window().addEventListener("DOMContentLoaded", () => {
                init();
            });
        } else {
            init();
        }
    }
}

ElementFeatures.afterContentLoaded(() => {
    ElementFeatures.installElementFeature("eop-aligned-slots", new AlignedSlotsFactory());
    ElementFeatures.installElementFeature("eop-horizontal-overflow", new HorizontalOverflowFactory());
});